import { useEffect, createRef } from 'react';

/**
 * Helper to do stuff when we click outside of an element
 * like on modals and... well modals actually
 * also handles pressing the ESC key
 *
 * @param {Boolean} active
 * @param {Function} dismiss
 * @returns clickRef
 */
const useClickOutside = (active, dismiss) => {
	const clickRef = createRef();

	const handleClickOutside = e => {
		if (active && clickRef && clickRef.current && !clickRef.current.contains(e.target)) {
			e.preventDefault();
			e.stopPropagation();
			dismiss();
		}
	};

	const handleEscape = e => {
		if (active && e.keyCode === 27) {
			dismiss();
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside);
		document.addEventListener("keyup", handleEscape);
		return () => {
			document.removeEventListener("click", handleClickOutside);
			document.removeEventListener("keyup", handleEscape);
		};
	});

	return clickRef;
};

export default useClickOutside;
